import React from 'react';
import classes from 'classnames';
import classNames from './TutorAvatarIcon.module.scss';
import UseAzureLanguageSettings from '@/hooks/UseAzureLanguageSettings';

// import tutorAvatarGif from '@/assets/images/tutorAvatarGif.gif';
// import tutorAvatar from '@/assets/images/tutorAvatarGifFirstFrame.jpg';

// import tutorAvatarGif from '@/assets/images/tutorAvatarSdk2.png';
// import tutorAvatar from '@/assets/images/tutorAvatarSdk2.png';

interface TutorAvatarIconProps {
  className?: string;
  animate?: boolean;
}

const TutorAvatarIcon = ({
  className,
  animate = true,
  ...props
}: React.DOMAttributes<HTMLDivElement> & TutorAvatarIconProps) => {
  const { avatarGif, avatarIcon } = UseAzureLanguageSettings();

  return (
    <div
      className={classes(classNames.icon, {
        [className || '']: className,
      })}
      {...props}
      style={{ backgroundImage: `url('${avatarIcon}')` }}
    >
      <img src={animate ? avatarGif : avatarIcon} alt='Tutor Avatar' />
    </div>
  );
};

export default TutorAvatarIcon;
